import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Cloud, RefreshCw, ChevronRight } from 'lucide-react';
import './Configuracion.css';

const Configuracion = () => {
  const navigate = useNavigate();

  const configOptions = [
    {
      title: 'OneDrive',
      description: 'Gestiona la conexión con Microsoft OneDrive para almacenamiento de archivos',
      icon: Cloud,
      path: '/configuracion/onedrive',
      color: '#0078d4'
    },
    {
      title: 'Integraciones',
      description: 'Configura las sincronizaciones automáticas con sistemas externos',
      icon: RefreshCw,
      path: '/configuracion/integraciones',
      color: '#2c5f2d'
    }
  ];

  return (
    <div className="configuracion-container">
      <div className="configuracion-header">
        <h1 className="configuracion-title">Configuración</h1>
        <p className="configuracion-subtitle">
          Gestiona las integraciones y configuraciones del sistema
        </p>
      </div>
      
      <div className="configuracion-content">
        <div className="config-options-grid">
          {configOptions.map((option) => {
            const IconComponent = option.icon;
            return (
              <div
                key={option.path}
                className="config-option-card"
                onClick={() => navigate(option.path)}
              >
                <div className="config-option-icon" style={{ color: option.color }}>
                  <IconComponent size={48} />
                </div>
                <div className="config-option-content">
                  <h3 className="config-option-title">{option.title}</h3>
                  <p className="config-option-description">{option.description}</p>
                </div>
                <div className="config-option-arrow">
                  <ChevronRight size={24} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Configuracion;
